// extracted by mini-css-extract-plugin
export default {"root":"schedule-v-2-page__components__schedule-header-content__center__root","filtersButton":"schedule-v-2-page__components__schedule-header-content__center__filtersButton"};